import React, { Component } from 'react';
import { ListGroup, Row, Col, OverlayTrigger, Button, Tooltip, Form } from 'react-bootstrap';
import "react-datepicker/dist/react-datepicker.css";
import { addDateChoose, removeDateChoose } from '../../actions/index';
import { connect } from 'react-redux';
import DateChooseAdd from "./DateChooseAdd";
import { sameDay, getDatesDisplayValue } from '../../backend/UIUtils'
import { translate } from "react-i18next";

class DateChooseList extends Component {

    constructor(props) {
        super(props);

        this.removeDateChoose = this.removeDateChoose.bind(this);
        this.createTerminSelected = this.createTerminSelected.bind(this);
        this.closeTermin = this.closeTermin.bind(this);
        this.state = {
            createTermin: false
        };
    }

    removeDateChoose(eventDate) {
        this.props.removeDateChoose(eventDate);
        this.props.updateModel("eventDates", eventDate, 'EVENTDATE_REMOVE');
    }

    createTerminSelected() {
        let oldState = this.state;
        this.setState(
            {
                ...oldState,
                createTermin: true
            }
        );
    }

    closeTermin() {
        let oldState = this.state;
        this.setState(
            {
                ...oldState,
                createTermin: false
            }
        );
    }

//<i class="fas fa-plus"></i>
    render() {
        const { t } = this.props;
        return (
            <div>
                <Row className="mb-3">
                    <Col className="mt-1" lg={10} xs={12}>
                        <Form.Label>{t("einenOderMehrere")}</Form.Label>
                    </Col>
                    <Col  lg={2} xs={12}>
                        <Button onClick={() => this.createTerminSelected()} className="float-left "  variant="success">
                        <span className="fas fa-plus mr-2 "/>{t("termin")}
                        </Button>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <ListGroup>
                            {this.props.eventDates.map((eventDate, i) => {

                                return (

                                    <ListGroup.Item variant="success" key={i}>
                                        <Row >

                                            <Col lg={6}>
                                                <Form.Label  > <strong>{
                                                    getDatesDisplayValue(eventDate.startDate, eventDate.endDate, sameDay(eventDate.startDate, eventDate.endDate), 'de')} </strong></Form.Label>

                                            </Col>


                                            <Col lg={1}  >
                                                <OverlayTrigger
                                                    key="top"
                                                    placement="top"
                                                    overlay={
                                                        <Tooltip id={`tooltip-top`}>
                                                            {t("entfernen")}
                                                        </Tooltip>
                                                    }>
                                                    <Button variant="outline-danger" onClick={() => this.removeDateChoose(eventDate)}><span className="fa fa-trash-alt"></span></Button>
                                                </OverlayTrigger>
                                            </Col>
                                            {eventDate.comment ?
                                                <Col lg={5} >
                                                    <Form.Label lg={10}>{eventDate.comment}</Form.Label>
                                                </Col>
                                                :
                                                ''
                                            }


                                        </Row>
                                    </ListGroup.Item>
                                )
                            })}
                        </ListGroup>
                    </Col>
                </Row>

                {(this.state.createTermin && !this.props.redirectLink)  ?
                    <div>
                        <Row>
                            <Col>
                                <hr />
                            </Col>
                        </Row>
                        <Row className="mt-2 mb-5">
                            <Col>
                                <DateChooseAdd onAdd={(eventDate) => {
                                    this.props.addDateChoose(eventDate);
                                    this.props.updateModel("eventDates", eventDate, 'EVENTDATE_ADD');
                                }}
                                    onClose={this.closeTermin}

                                />
                            </Col>
                        </Row>
                    </div>
                    :
                    ''
                }


            </div>
        )
    }
}

let mapStateToProps = (state) => {
    return {
        eventDates: state.eventDates
    }
}

let mapDispatchToProps = {
    addDateChoose: addDateChoose,
    removeDateChoose: removeDateChoose
}

let DateChooseListContainer =
    connect(mapStateToProps, mapDispatchToProps)(DateChooseList);

export default translate("translations")(DateChooseListContainer);
